import React, { useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import api from "../api";
import CreateUserModal from "../components/CreateUserModal";

const UserPage = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const getUsers = async () => {
        try {
            setLoading(true);
            const res = await api.get("/users");
            // Assuming the API returns the list directly or in a property, adjusting to typical pattern
            // If the API returns an array directly:
            setUsers(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            message.error("Error al obtener usuarios");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16,
                    flexWrap: "wrap",
                    gap: "16px",
                }}
            >
                <h2 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Gestión de Usuarios</h2>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>
                    Nuevo Usuario
                </Button>
            </div>

            <Table
                dataSource={users}
                loading={loading}
                rowKey="id" // Assuming 'id' exists, otherwise fallback to 'nombreUsuario' might be safer but 'id' is standard
                columns={[
                    { title: "Usuario", dataIndex: "nombreUsuario" },
                    { title: "Rol", dataIndex: "rol" },
                    { title: "Observación", dataIndex: "observacion" },
                ]}
                scroll={{ x: 'max-content' }}
            />

            <CreateUserModal
                open={open}
                onCancel={() => setOpen(false)}
                onSuccess={() => {
                    setOpen(false);
                    getUsers();
                }}
            />
        </>
    );
};

export default UserPage;
